<template>
    <div class="article-home-course">
        <p>Ready to take your West Coast Swing following to the next level?</p>
        <p>
            Build your foundation, find your style and dance with confidence - with Lauren's fun and accessible online
            course.
        </p>
        <p>Watch the first two lessons for free!</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleHomeCourse',
};
</script>
